module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm11.3 20h-9.064l3.552-7.106a2 2 0 1 0-3.578-1.788l-4 8c-.144.288-.19.894-.19.894H4.7c-.444-2-.7-2.596-.7-4C4 9.382 9.382 4 16 4s12 5.382 12 12c0 1.404-.256 2-.7 4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/gauge-1.js
// module id = 1158
// module chunks = 14